"use client";

import { Button } from "@workspace/ui/components/button";
import { signIn } from "next-auth/react";
import { useTranslations } from "next-intl";

export function ZitadelSignInButton() {
  const t = useTranslations("Login");

  return (
    <form
      action={async () => {
        await signIn("zitadel", {
          redirectTo: "/"
        });
      }}
    >
      <Button className="w-full" type="submit">
        {t("signInWithAthaLabs")}
      </Button>
    </form>
  );
}
